
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.1 35.76c-.86 4.53-1.92 8.87-5.04 11.13-.96-6.84 1.42-11.98 2.52-17.43-1.88-3.17.23-9.56 4.2-7.98 4.89 1.93-4.23 11.79 1.89 13.02 6.4 1.29 9.01-11.1 5.04-15.12-5.73-5.81-16.68-.13-15.33 8.19.33 2.04 2.43 2.65.84 5.46-3.67-.81-4.76-3.71-4.62-7.56.23-6.31 5.67-10.73 11.13-11.34 6.91-.77 13.39 2.54 14.28 9.03 1.01 7.33-3.12 15.27-10.5 14.7-2-.16-2.84-1.15-4.41-2.1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M30.45 51.9c11.847 0 21.45-9.603 21.45-21.45C51.9 18.604 42.297 9 30.45 9 18.604 9 9 18.604 9 30.45 9 42.297 18.604 51.9 30.45 51.9z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    